import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { insurances } from "../data/site";
import { SectionLabel } from "./PageHeader";
import { useLang } from "../i18n";

export const InsurancesMarquee = () => {
  const { t } = useLang();
  const row = [...insurances, ...insurances];
  return (
    <section className="py-16 sm:py-20 bg-white overflow-hidden border-t border-black/5">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <SectionLabel className="mb-5 justify-center">
            <ShieldCheck size={14} /> {t("Insurances we accept")}
          </SectionLabel>
          <p className="mx-auto max-w-2xl text-ink/65 leading-relaxed">
            {t(
              "We proudly partner with a range of insurance providers to help make care accessible for your family."
            )}
          </p>
        </motion.div>
      </div>

      <div className="relative mt-12">
        {/* fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-white to-transparent" />
        <div className="flex w-max gap-5 animate-marquee">
          {row.map((item, i) => (
            <div
              key={i}
              data-testid={`insurance-${i}`}
              className="flex items-center justify-center gap-3 rounded-2xl bg-white border border-black/5 shadow-[0_8px_24px_rgba(58,118,166,0.08)] px-7 py-5 h-24 min-w-[220px] whitespace-nowrap"
            >
              {item.logo ? (
                <img
                  src={item.logo}
                  alt={`${item.name} logo`}
                  className="max-h-12 w-auto object-contain"
                  loading="lazy"
                />
              ) : (
                <>
                  <span className="grid place-items-center h-9 w-9 rounded-full bg-teal/10 text-teal shrink-0">
                    <ShieldCheck size={18} />
                  </span>
                  <span className="font-heading font-semibold text-ink text-[1.05rem]">{item.name}</span>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
